import React, {useEffect} from 'react';
import { withStyles } from '@material-ui/core/styles';
import Button from '@material-ui/core/Button';
import Dialog from '@material-ui/core/Dialog';
import MuiDialogTitle from '@material-ui/core/DialogTitle';
import MuiDialogContent from '@material-ui/core/DialogContent';
import MuiDialogActions from '@material-ui/core/DialogActions';
import IconButton from '@material-ui/core/IconButton';
import Typography from '@material-ui/core/Typography';
import PropTypes from 'prop-types';

const styles = theme => ({
  root: {
    margin: 0,
    padding: theme.spacing(2),
  },
  closeButton: {
    position: 'absolute',
    right: theme.spacing(1),
    top: theme.spacing(1),
    color: theme.palette.grey[500],
  },
});

const DialogTitle = withStyles(styles)(props => {
  const { children, classes, onClose, ...other } = props;
  return (
    <MuiDialogTitle disableTypography className={classes.root} {...other}>
      <Typography variant="h6">{children}</Typography>
      {onClose ? (
        <button type="button" class="close" data-dismiss="modal" aria-label="Close" onClick={onClose}>
            <span aria-hidden="true">&times;</span>
        </button>
      ) : null}
    </MuiDialogTitle>
  );
});

const DialogContent = withStyles(theme => ({
  root: {
    padding: theme.spacing(2),
  },
}))(MuiDialogContent);

const DialogActions = withStyles(theme => ({
  root: {
    margin: 0,
    padding: theme.spacing(1),
  },
}))(MuiDialogActions);

export default function CustomizedDialogs(props) {
  const{modalTitle, openDialog, onCloseDialog, isOpen, width, buttonText}= props;
  //const [open, setOpen] = React.useState(false);
  /*useEffect(() => {
    return setOpen(openDialog);
  },[openDialog]);*/

  const handleClose = (e) => {
    onCloseDialog()
  };

  return (
    <div>
      <Dialog onClose={handleClose} aria-labelledby="customized-dialog-title" open={isOpen} fullWidth={true} maxWidth={width}>
        <DialogTitle id="customized-dialog-title" onClose={handleClose}>
          {modalTitle}
        </DialogTitle>
        <DialogContent >
          {props.children}
        </DialogContent>
        <DialogActions>
          <Button autoFocus onClick={handleClose} color="primary">
            {buttonText}
          </Button>
        </DialogActions>
      </Dialog>
    </div>
  );
}
CustomizedDialogs.propTypes = {
  open:PropTypes.bool,
  width:PropTypes.oneOf(['xs', 'sm','md','lg','xl']).isRequired,
  modalTitle:PropTypes.string,
  buttonText:PropTypes.string
}

CustomizedDialogs.defaultProps = {
  buttonText: 'Close',

};
